import { IonButton, IonCol, IonImg, IonItem, IonLabel, IonList, IonRadio, IonRadioGroup, IonRow, useIonViewDidEnter } from "@ionic/react";
import React, { useEffect, useState } from "react";
import PayComponent from "../components/PayComponent";
import { User } from "../models/data";
import { translation } from "../models/translation";
import { useExternalScript } from "../services/load_external_script";

import { fetchPmtInitationData, upDatePaymentInfo } from "../services/pmt_service";
import UserTerms from "./UserTerms";

interface paymentObject {
    user: User,
    amount: number,
    type: string,
    donateData?: any,
    resetCredit?: any
}

type LanguageMap = {
    [key: string]: string;
};


const CreditPay: React.FC<paymentObject> = (props) => {

    useIonViewDidEnter(() => {
        if (props.type === "credit") {
            props.resetCredit();
        }
    })

    useEffect(() => {
        setAmount(props.amount);
    }, [props.amount])

    const siteText = translation();

    const lan = translation().lan.replace("/","");

    const languages:LanguageMap={
        en:'en-CH',
        fr:'fr-CH',
        de:'de-CH',
    }

    const getLanguage = (lang:string)=>{
        if(languages.hasOwnProperty(lang)){
            return languages[lang]
        }
    }

    const pmtNotes = [{
        key: 'finance_C',
        notes: siteText.donateDirectlyPayFeeTxt + '1.80% ',
        id: 97627,
        fee: 0.018
    },
    {
        key: 'finance_E',
        notes: siteText.donateDirectlyPayFeeTxt + '1.80% ',
        id: 97628,
        fee: 0.018
    },
    {
        key: 'finance_Pay',
        notes: siteText.donateDirectlyPayFeeTxt + '1.80% ',
        id: 193207,
        fee: 0.018
    },
    {
        key: 'creditcard',
        notes: siteText.donateDirectlyPayFeeTxt + '1.65%',
        id: 103396,
        fee: 0.0165
    },

    {
        key: 'twint',
        notes: siteText.donateDirectlyPayFeeTxt + '1.40%',
        id: 99165,
        fee: 0.014
    },
    {
        key: 'invoice',
        notes: siteText.donateDirectlyPayFeeTxt + '0.0%',
        id: 103397,
        fee: 0.00
    }
    ]


    const [amount, setAmount] = useState<number>();
    const defalutCommission = 0.01;
    const [iframeUrl, setIframeUrl] = useState();
    const [paymentMethods, setPaymentMethods] = useState<any>();
    const [chosenMethod, setChosenMethod] = useState<any>();
    const [transactionId, setTransactionId] = useState<any>();
    const [version, setVersion] = useState<any>();
    const [chosenMethodName, setChosenMethodName] = useState<any>();
    const [contribution, setContribution] = useState<any>(1);
    const [reloading, setRelaoding] = useState<boolean>(false);
    const [totalAmount, setTotalAmount] = useState<any>(() => {
        return (+props.amount)
    });
    const [fee, setFee] = useState<any>(0);

    const [userTerms, showUserTerms] = useState<boolean>(false);



    //initialize state to null
    let state = '';

    //wait for component ready
    useEffect(() => {
        let mounted = true;
        fetchPmtInitationData(props.user, totalAmount, props.type,getLanguage(lan)).then(tools => {
            if (mounted) {
                if (!tools.error) {
                    let { jsUrl, pmtMtds, transactId, version } = tools.message
                    console.log(pmtMtds);
                    setIframeUrl(jsUrl);
                    setPaymentMethods(pmtMtds);
                    setTransactionId(transactId);
                    setVersion(version);
                }
            }

        })

        return () => {
            mounted = false;
        }

    }, [props.type, props.amount])

    const updateTotalAmount = () => {
        setTotalAmount((+props.amount + (props.amount * fee)).toFixed(2))
    }

    useEffect(() => {
        updateTotalAmount();
    }, [contribution, fee, chosenMethod]);


    useEffect(() => {
        let mounted = true;
        /*if (transactionId) { updatePayment(); }
        return () => {
            mounted = false;
        }*/
        if (transactionId) {
            setRelaoding(true);
            console.log(`version: ${version}`);
            upDatePaymentInfo(props.user, totalAmount, props.type, transactionId, version).then(
                m => {
                    //console.log(m);
                    if (mounted) {
                        if (!m.error) {
                            let  newversion  = m.message.version;
                            resetReloading(newversion);
                        }
                        return m;
                    }
                }
            )
        }
        return () => {
            mounted = false;
        }

    }, [chosenMethod])
   

    const resetReloading = (nversion: any) => {
        console.log(`nversion: ${nversion}`);
        setVersion(nversion);
        setRelaoding(false)
    }
    /**
     * Return the current state of the payment method script that is loaded external
     */
    state = useExternalScript(iframeUrl);

    /**
    * Choose amout text to show depending on the users current action
    * Checks the type prop value of the component
    * @returns amount text component
    */
    const AmountText = () => {
        if (props.type === 'credit') {
            return (
                <>{siteText.creditAccountPaymentTitle.replace('%%amount%%', '' + amount)}</>
            )
        } else {
            return (
                <>{siteText.donateDirectlyPayTitle.replace('%%amount%%', '' + amount)}</>
            )
        }
    }

    /**
     * Find the corresponding note for the current payment method in payment notes
     * @input :name  of the payment method
     * @returns: first corresponding method by name in payments notes

    */
    const getNotes = (id: number) => {
        let noteList = pmtNotes.filter((e, i, arr) => {
            if (e.id === id) return pmtNotes[i]
        })
        if (noteList.length > 0) {
            return noteList[0].notes
        }
        return '';
    }

    /**
     * Find the corresponding note for the current payment method in payment notes
     * @input :name  of the payment method
     * @returns: first corresponding method by name in payments notes

    */
    const getFee = (id: number) => {
        let noteList = pmtNotes.filter((e, i, arr) => {
            if (e.id === id) return pmtNotes[i]
        })
        if (noteList.length > 0) {
            return noteList[0].fee
        }
        return '';
    }

    const toggleContribution = () => {
        let current = contribution;
        setContribution(current !== 0 ? 0 : 1);
    }

   

    const updateMethod = ({ value }: any) => {
        setChosenMethod(value.id);
        setFee(value.fee);
        setChosenMethodName(value.name);
    }

    /*Close open user terms  */
    const toggleUserTerms = () => {
        let current = userTerms;
        showUserTerms(!current);
    }

    return (
        <>
            {!userTerms ? <>
                <IonRow>
                    <IonCol>
                        <h1><AmountText /></h1>
                        <p>{siteText.donateDirectlyPayTotal.replace('%%amount%%', totalAmount)}</p>
                        <h3>{siteText.donateDirectlyPayMethodSelect}</h3>
                        <p> {siteText.donateDirectlyPayFeeNotice}
                        </p>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol sizeMd="8" >
                        <IonList>
                            <IonRadioGroup aria-disabled={reloading} onIonChange={e => { updateMethod(e.detail) }}>
                                {paymentMethods && paymentMethods.map((method: any, key: any) => {
                       
                                        return (
                                            <IonItem key={key}>
                                                <IonImg style={{maxWidth:"80px"}} src={method.image_url} slot="start"></IonImg>
                                                <IonLabel className="ion-text-wrap">
                                                {lan==="fr" && method.resolved_title["fr-FR"]}
                                                {lan==="de" && method.resolved_title["de-DE"]}
                                                {lan==="en" && method.resolved_title["en-US"]}
                                                    <br></br>
                                                    <span className="pmt_notes">
                                                        {getNotes(method.id)}
                                                    </span>
                                                </IonLabel>
                                                <IonRadio value={{ id: method.id, fee: getFee(method.id), name: method.name }} disabled={reloading} />
                                            </IonItem>
                                        )
                                    
                                })}

                            </IonRadioGroup>
                        </IonList>
                    </IonCol>
                </IonRow>

                <IonRow>
                    <IonCol sizeMd="4">
                        <ul id="payment-errors"></ul>
                        <div id="payment-form"></div>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol>

                        <div>
                            {state === "loading" && <p>...</p>}
                            {(state === "ready" && chosenMethod) ? <PayComponent siteText={siteText} totalAmount={totalAmount} user={props.user} amount={amount} method={chosenMethodName} commition={props.amount * defalutCommission * contribution} type={props.type} reloading={reloading} donateData={props.donateData} pmtMethod={chosenMethod}  transactionId={transactionId} version={version} /> : <></>}
                            {(state !== "ready" || !chosenMethod) ? <IonButton disabled={true}>{props.type === "credit" ? siteText.creditAccountPaymentPrimary : siteText.donateDirectlypayPrimary}</IonButton> : ''}
                        </div>
                    </IonCol>
                </IonRow>

            </> :
                <UserTerms goBack={toggleUserTerms}></UserTerms>}
        </>
    )
}


export default CreditPay;